export const COUNTRY_COLOR_CONFIGURATION: string[] = [
    '#D7D5D6',
    '#96D7D2',
    '#F26921',
    '#FFC832',
    '#503291',
    '#2DBECD',
    '#0F69AF',
    '#149B5F',
    '#414450',
    '#BD268F',
    '#A5CD50',
    '#9D96C9',
    '#EB3C96'
];